import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { UpdateOrderUseCase } from '../orderTableModule/useCases/updateOrderUseCase';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';
import { OrderTemplateRepository } from '@/coreInfrastructureModule/Repositories/OrderTemplateRepository';
import { GetUnorderedArrivalUseCase } from '../orderTableModule/useCases/getUnorderedArrivalUseCase';
import { BulkDeleteOrderUseCase } from '../orderTableModule/useCases/bulkDeleteOrderUseCase';
import { UpdateOutputFlagUseCase } from '../orderTableModule/useCases/updateOutputFlagUseCase';
import { IUnmanagedBusinessRepository } from '@/coreInfrastructureModule/interfaces/IUnmanagedBusinessRepository';
import { UnmanagedBusinessRepository } from '@/coreInfrastructureModule/Repositories/UnmanagedBusinessRepository';
import { BulkSaveUnmanagedBusinessUseCase } from '@/coreUseCasesModule/unmanagedBusiness/bulkSaveUnmanagedBusinessUseCase';
import { DeleteAllUnmanagedBusinessUseCase } from '@/coreUseCasesModule/unmanagedBusiness/deleteAllUnmanagedBusinessUseCase';
import { DeleteByFileTypeUnmanagedBusinessUseCase } from '@/coreUseCasesModule/unmanagedBusiness/deleteByFileTypeUnmanagedBusinessUseCase';
import { DeleteUnmanagedBusinessUseCase } from '@/coreUseCasesModule/unmanagedBusiness/deleteUnmanagedBusinessUseCase';
import { GetAllUnmanagedBusinessUseCase } from '@/coreUseCasesModule/unmanagedBusiness/getAllUnmanagedBusinessUseCase';
import { GetUnmanagedBusinessUseCase } from '@/coreUseCasesModule/unmanagedBusiness/getUnmanagedBusinessUseCase';
import { SaveUnmanagedBusinessUseCase } from '@/coreUseCasesModule/unmanagedBusiness/saveUnmanagedBusinessUseCase';
import { OrderControlRepository } from '@/coreInfrastructureModule/Repositories/OrderControlRepository';
import { GetOrderControlUseCase } from '@/orderControlModule/useCases/getOrderControlUseCase';
import { IOrderControlRepository } from '@/coreInfrastructureModule/interfaces/IOrderControlRepository';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { ISupplierForecastRepository } from '@/coreInfrastructureModule/interfaces/ISupplierForecastRepository';
import { GetAggregateBusinessIdUseCase } from '@/recommendOrderModule/useCases/getAggregateBusinessIdUseCase';
import { GetBusinessUseCase } from '@/recommendOrderModule/useCases/getBusinessUseCase';
import { PutLeadTimeUseCase } from '@/recommendOrderModule/useCases/putLeadTimeUseCase';
import { PutMoqUseCase } from '@/recommendOrderModule/useCases/putMoqUseCase';
import { PutStdInventoryIndicesUseCase } from '@/recommendOrderModule/useCases/putStdInventoryIndicesUseCase';
import { PutSupplierForecastUseCase } from '@/recommendOrderModule/useCases/putSupplierForecastUseCase';
import { AggregateBusinessRepository } from '@/coreInfrastructureModule/Repositories/AggregateBusinessRepository';
import { SupplierForecastRepository } from '@/coreInfrastructureModule/Repositories/SupplierForecastRepository';
import { UpsertOrderUseCase } from '@/coreUseCasesModule/order/upsertOrderUseCase';
import { UpdateOrderMemoUseCase } from '@/orderTableModule/useCases/updateOrderMemoUseCase';
import { DeleteOrderMemoUseCase } from '@/orderTableModule/useCases/deleteOrderMemoUseCase';
import { RecommendOrderRepository } from '@/coreInfrastructureModule/Repositories/RecommendOrderRepository';
import { IRecommendOrderRepository } from '@/coreInfrastructureModule/interfaces/IRecommendOrderRepository';
import { GetAggregateBusinessIdsRecommendOrderListUseCase } from '@/recommendOrderModule/useCases/getAggregateBusinessIdsRecommendOrderListUseCase';
import { SaveAggregateBusinessIdsForRecommendOrderUseCase } from '@/orderControlModule/useCases/saveAggregateBusinessIdsForRecommendOrderUseCase';
import { InventoryRepository } from '@/coreInfrastructureModule/Repositories/InventoryRepository';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { BaseBusinessRepository } from '@/coreInfrastructureModule/Repositories/BaseBusinessRepository';
import { GetEditBusinessChildBusinessUseCase } from '@/editBusinessModule/useCases/getEditBusinessChildBusinessUseCase';
import { GetEditBusinessAggregateBusinessUseCase } from '@/editBusinessModule/useCases/getEditBusinessAggregateBusinessUseCase';
import { PutAggregateBusinessUseCase } from '@/editBusinessModule/useCases/putAggregateBusinessUseCase';
import { PutAggregateBusinessMemoUseCase } from '@/coreUseCasesModule/aggregateBusinessMemo/PutAggregateBusinessMemoUseCase';
import { CheckDuplicateAggregateBusinessUseCase } from '@/coreUseCasesModule/editBusiness/checkDuplicateAggregateBusiness';
import { CheckDuplicateBaseBusinessUseCase } from '@/coreUseCasesModule/editBusiness/checkDuplicateBaseBusinessUseCase';
import { PutBaseBusinessUseCase } from '@/editBusinessModule/useCases/putBaseBusinessUseCase';
import { IBaseBusinessManageRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessManageRepository';
import { BaseBusinessManageRepository } from '@/coreInfrastructureModule/Repositories/BaseBusinessManageRepository';
import { GetTableHeaderPreferenceUseCase } from '@/corePagesModule/BaseTableContent/useCases/getTableHeaderPreferenceUseCase';
import { SaveTableHeaderPreferenceUseCase } from '@/corePagesModule/BaseTableContent/useCases/saveTableHeaderPreferenceUseCase';
import { SaveTableHeaderHidePreferenceUseCase } from '@/corePagesModule/BaseTableContent/useCases/saveTableHeaderHidePreferenceUseCase';
import { BulkSaveTableHeaderHidePreferenceUseCase } from '@/corePagesModule/BaseTableContent/useCases/bulkSaveTableHeaderHidePreferenceUseCase';
import { DeleteAggregateBusinessMemoUseCase } from '@/coreUseCasesModule/aggregateBusinessMemo/DeleteAggregateBusinessMemoUseCase';
import { PutBusinessMemoUseCase } from '@/InventoryControlModule/useCases/PutBusinessMemoUseCase';
import { DeleteBusinessMemoUseCase } from '@/InventoryControlModule/useCases/DeleteBusinessMemoUseCase';
import { GroupRepository } from '@/coreInfrastructureModule/Repositories/GroupRepository';
import { IGroupRepository } from '@/coreInfrastructureModule/interfaces/IGroupRepository';
import { GetInventoryBusinessUseCase } from '@/InventoryControlModule/useCases/GetInventoryBusinessUseCase';
import { IForecastAccuracyRepository } from '@/coreInfrastructureModule/interfaces/IForecastAccuracyRepository';
import { ForecastAccuracyRepository } from '@/coreInfrastructureModule/Repositories/ForecastAccuracyRepository';
import { GetForecastAccuracyHistoryUseCase } from '@/InventoryControlModule/useCases/GetForecastAccuracyHistoryUseCase';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';
import { TrashBinRepository } from '@/coreInfrastructureModule/Repositories/TrashBinRepository';
import { DeleteDeletionAggregateBusinessUseCase } from '@/coreUseCasesModule/trashBin/deleteDeletionAggregateBusinessUseCase';
import { GetInventoryUseCase } from '@/InventoryControlModule/useCases/GetInventoryUseCase';
import { DeleteDeletionBaseBusinessUseCase } from '@/coreUseCasesModule/trashBin/deleteDeletionBaseBusinessUseCase';
import { GetBusinessNameUseCase } from '@/coreUseCasesModule/getItem/GetBusinessNameUseCase';
import { GetBusinessNumberUseCase } from '@/coreUseCasesModule/getItem/GetBusinessNumberUseCase';
import { GetWarehouseNameUseCase } from '@/coreUseCasesModule/getItem/GetWarehouseNameUseCase';
import { GetWarehouseNumberUseCase } from '@/coreUseCasesModule/getItem/GetWarehouseNumberUseCase';
import { GetSupplierNameUseCase } from '@/coreUseCasesModule/getItem/GetSupplierNameUseCase';
import { GetSupplierNumberUseCase } from '@/coreUseCasesModule/getItem/GetSupplierNumberUseCase';
import { GetCustomerNameUseCase } from '@/coreUseCasesModule/getItem/GetCustomerNameUseCase';
import { GetCustomerNumberUseCase } from '@/coreUseCasesModule/getItem/GetCustomerNumberUseCase';
import { GetSalesDestinationNameUseCase } from '@/coreUseCasesModule/getItem/GetSalesDestinationNameUseCase';
import { GetSalesDestinationNumberUseCase } from '@/coreUseCasesModule/getItem/GetSalesDestinationNumberUseCase';
import { CheckNewOptionDuplicateUseCase } from '@/corePagesModule/updateBusinessModal/useCases/checkNewOptionDuplicateUseCase';
import { IRegisterBusinessRepository } from '@/coreInfrastructureModule/interfaces/IRegisterBusinessRepository';
import { RegisterBusinessRepository } from '@/coreInfrastructureModule/Repositories/RegisterBusinessRepository';
import { CreateNewAggregateBusinessUseCase } from '@/coreUseCasesModule/editBusiness/CreateNewAggregateBusinessUseCase';
import { CreateNewBaseBusinessUseCase } from '@/coreUseCasesModule/editBusiness/CreateNewBaseBusinessUseCase';
import { PutOrderPackageUseCase } from '@/recommendOrderModule/useCases/putOrderPackageUseCase';
import { UpsertTransactionValuesUseCase } from '@/InventoryControlModule/useCases/UpsertTransactionValuesUseCase';
import { SaveReminderMailSettingsUseCase } from '@/orderTableModule/useCases/saveReminderMailSettingsUseCase';
import { UpdateOrderReminderMailIdUseCase } from '@/orderTableModule/useCases/updateOrderReminderMailIdUseCase';
import { GetReminderDataUseCase } from '@/orderTableModule/useCases/getReminderDataUseCase';
import { CleanupOrderReminderMailIdUseCase } from '@/orderTableModule/useCases/cleanupOrderReminderMailIdUseCase';
import { OrderGroupRepository } from '@/coreInfrastructureModule/Repositories/OrderGroupRepository';
import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';
import { CreateCombinedOrderUseCase } from '@/InventoryControlModule/useCases/CreateCombinedOrderUseCase';
import { PostOrderGroupUseCase } from '@/orderTableModule/useCases/postOrderGroupUseCase';
import { GetOrderGroupUseCase } from '@/orderTableModule/useCases/getOrderGroupUseCase';
import { BulkPostOrderToOrderGroupUseCase } from '@/orderTableModule/useCases/bulkPostOrderToOrderGroupUseCase';
import { DeleteOrderGroupUseCase } from '@/orderTableModule/useCases/deleteOrderGroupUseCase';
import { UpdateOrderGroupUseCase } from '@/orderTableModule/useCases/updateOrderGroupUseCase';
import { BulkDeleteOrderToOrderGroupUseCase } from '@/orderTableModule/useCases/bulkDeleteOrderToOrderGroupUseCase';
import { OutputOrderUseCase } from '@/orderTableModule/useCases/outputOrderUseCase';
import { IUserRepository } from '@/coreInfrastructureModule/interfaces/IUserRepository';
import { UserRepository } from '@/coreInfrastructureModule/Repositories/UserRepository';
import { GetFilterInfoUseCase } from '@/corePagesModule/SelectInput/useCases/getFilterInfoUseCase';
import { IFilterInfoRepository } from '@/coreInfrastructureModule/interfaces/IFilterInfoRepository';
import { FilterInfoRepository } from '@/coreInfrastructureModule/Repositories/FilterInfoRepository';
import { ICustomerForecastRepository } from '@/coreInfrastructureModule/interfaces/ICustomerForecastRepository';
import { CustomerForecastRepository } from '@/coreInfrastructureModule/Repositories/CustomerForecastRepository';
import { GetAllUsersUseCase } from '@/corePagesModule/user/useCases/getAllUsersUseCase';
import { VerifyUserIdsUseCase } from '@/registerInputModule/useCases/VerifyUserIdsUseCase';
import { VerifyUserIdsRepository } from '@/coreInfrastructureModule/Repositories/VerifyUserIdsRepository';
import { IVerifyUserIdsRepository } from '@/coreInfrastructureModule/interfaces/IVerifyUserIdsRepository';
import { GetOrderTemplateListUseCase } from '@/orderTemplateModule/useCases/getOrderTemplateListUseCase';
import { GetOrderTemplateDetailUseCase } from '@/orderTemplateModule/useCases/getOrderTemplateDetailUseCase';
import { CreateOrderTemplateUseCase } from '@/orderTemplateModule/useCases/createOrderTemplateUseCase';
import { UpdateOrderTemplateUseCase } from '@/orderTemplateModule/useCases/updateOrderTemplateUseCase';
import { DeleteOrderTemplateUseCase } from '@/orderTemplateModule/useCases/deleteOrderTemplateUseCase';
import { CreateOrderTemplateUploadUrlUseCase } from '@/orderTemplateModule/useCases/createOrderTemplateUploadUrlUseCase';
import { GetOrderTemplateDownloadUrlUseCase } from '@/orderTemplateModule/useCases/getOrderTemplateDownloadUrlUseCase';
import { YearMonthRangeInfoRepository } from '@/coreInfrastructureModule/Repositories/YearMonthRangeInfoRepository';
import { IYearMonthRangeInfosRepository } from '@/coreInfrastructureModule/interfaces/IYearMonthRangeInfosRepository';
import { GetTableFilterPreferenceUseCase } from '@/corePagesModule/BaseTableContent/useCases/getTableFilterPreferenceUseCase';
import { BulkSaveTableFilterPreferenceUseCase } from '@/corePagesModule/BaseTableContent/useCases/bulkSaveTableFilterPreferenceUseCase';
import { GetHiddenTableHeaderPreferenceUseCase } from '@/InventoryControlModule/useCases/GetHiddenTableHeaderPreferenceUseCase';
import { PutLastCheckedUseCase } from '@/recommendOrderModule/useCases/putLastCheckedUseCase';
import { bulkPutUnpaidOrderedOrderUseCase } from '@/recommendOrderModule/useCases/bulkPutUnpaidOrderedOrderUseCase';
import { IOrderBasisRepository } from '@/coreInfrastructureModule/interfaces/IOrderBasisRepository';
import { OrderBasisRepository } from '@/coreInfrastructureModule/Repositories/OrderBasisRepository';
import { GetOrderBasisUseCase } from '@/orderTableModule/useCases/getOrderBasisUseCase';
import { GetRelatedTransactionsDetailUseCase } from '@/recommendOrderModule/useCases/getRelatedTransactionsDetailUseCase';
import { GetLongTermCustomerForecastUseCase } from '@/recommendOrderModule/useCases/getLongTermCustomerForecastUseCase';
import { ExportInventoryExcelUseCase } from '@/InventoryControlModule/useCases/ExportInventoryExcelUseCase';
import { GetForecastAccuracyRateUseCase } from '@/customerForecastModule/useCases/getForecastAccuracyRateUseCase';
import { ExportForecastAccuracyRateUseCase } from '@/customerForecastModule/useCases/exportForecastAccuracyRateUseCase';
import { ExportCustomerForecastUseCase } from '@/customerForecastModule/useCases/exportCustomerForecastUseCase';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { ForecastForReceiptRepository } from '@/coreInfrastructureModule/Repositories/ForecastForReceiptRepository';
import { BulkGetForecastForReceiptStaffUseCase } from '@/customerForecastModule/useCases/bulkGetForecastForReceiptStaffUseCase';
import { GetForecastForReceiptSummaryUseCase } from '@/customerForecastModule/useCases/getForecastForReceiptSummaryUseCase';
import { DeleteBaseBusinessForecastForReceiptUseCase } from '@/customerForecastModule/useCases/deleteBaseBusinessForecastForReceiptUseCase';
import { DeleteForecastForReceiptUseCase } from '@/customerForecastModule/useCases/deleteForecastForReceiptUseCase';
import { CreateForecastForReceiptUseCase } from '@/customerForecastModule/useCases/createForecastForReceiptUseCase';
import { AddBaseBusinessForecastForReceiptUseCase } from '@/customerForecastModule/useCases/addBaseBusinessForcastForReceiptUseCase';
import { updateForecastForReceiptUseCase } from '@/customerForecastModule/useCases/updateForecastForReceiptUseCase';
import { GetOutputForecastForReceiptExcelDataUseCase } from '@/customerForecastModule/useCases/getOutputForecastForReceiptExcelDataUseCase';
import { GetInventoryDashboardOverviewUseCase } from '@/inventoryDashboardModule/useCases/GetInventoryDashboardOverviewUseCase';
import { GetInventoryDashboardDetailAggBizUseCase } from '@/inventoryDashboardModule/useCases/GetInventoryDashboardDetailAggBizUseCase';
import { GetInventoryDashboardDetailBaseBizUseCase } from '@/inventoryDashboardModule/useCases/GetInventoryDashboardDetailBaseBizUseCase';
import { KpiRepository } from '@/coreInfrastructureModule/Repositories/KpiRepository';
import { GetKpiUseCase } from '@/inventoryDashboardModule/useCases/GetKpiUseCase';
import { PostKpiUseCase } from '@/inventoryDashboardModule/useCases/BulkPostKpiUseCase';
import { GetByDimensionAggBizUseCase } from '@/inventoryDashboardModule/useCases/GetByDimensionAggBizUseCase';
import { GetAggregateBusinessResponsibleUsersForKpiUseCase } from '@/inventoryDashboardModule/useCases/GetAggregateBusinessResponsibleUsersForKpiUseCase';
import { GetByDimensionBaseBizUseCase } from '@/inventoryDashboardModule/useCases/GetByDimensionBaseBizUseCase';
import { GetInventoryDashboardDetailAggBizWithAlertUseCase } from '@/inventoryDashboardModule/useCases/GetInventoryDashboardDetailAggBizWithAlertUseCase';
import { IUnmatchedOrderRepository } from '@/coreInfrastructureModule/interfaces/IUnmatchedOrderRepository';
import { UnmatchedOrderRepository } from '@/coreInfrastructureModule/Repositories/UnmatchedOrderRepository';
import { GetUnmatchedOrdersUseCase } from '@/unmatchedOrderModule/useCases/GetUnmatchedOrdersUseCase';
import { UpdateUnmatchedOrderUseCase } from '@/unmatchedOrderModule/useCases/UpdateUnmatchedOrderUseCase';
import { BulkDeleteUnmatchedOrderUseCase } from '@/unmatchedOrderModule/useCases/BulkDeleteUnmatchedOrderUseCase';
import { GetExistingOrdersUseCase } from '@/unmatchedOrderModule/useCases/GetExistingOrdersUseCase';
import { BulkRegisterOrderBusinessUseCase } from '@/coreUseCasesModule/order/bulkRegisterOrderBusinessUseCase';
import { GetAggregateBusinessUseCase } from '@/coreUseCasesModule/getItem/GetAggregateBusinessUseCase';
import { RegisterUnmatchedOrderBusinessUseCase } from '@/unmatchedOrderModule/useCases/RegisterUnmatchedOrderBusinessUseCase';
import { BulkRegisterUnmatchedOrderBusinessUseCase } from '@/unmatchedOrderModule/useCases/BulkRegisterUnmatchedOrderBusinessUseCase';
import { ISettingRepository } from '@/coreInfrastructureModule/interfaces/ISettingRepository';
import { SettingRepository } from '@/coreInfrastructureModule/Repositories/SettingRepository';
import { GetDashboardAlertSettingUseCase } from '@/inventoryDashboardModule/useCases/GetDashboardAlertSettingUseCase';
import { PutDashboardAlertSettingUseCase } from '@/inventoryDashboardModule/useCases/PutDashboardAlertSettingUseCase';
import { PutRecommendHiddenUseCase } from '@/orderControlModule/useCases/putRecommendHiddenUseCase';
import { BulkUpdateOrderEtaUseCase } from '@/orderTableModule/useCases/bulkUpdateOrderEtaUseCase';

/**
 * DIContainer
 */
class DiContainer {
  // #region Repositories
  public aggregateBusinessRepository: IAggregateBusinessRepository;
  public baseBusinessRepository: IBaseBusinessRepository;
  public baseBusinessManageRepository: IBaseBusinessManageRepository;
  public inventoryRepository: IInventoryRepository;
  public orderRepository: IOrderRepository;
  public orderTemplateRepository: IOrderTemplateRepository;
  public orderControlRepository: IOrderControlRepository;
  public unmanagedBusinessRepository: IUnmanagedBusinessRepository;
  public supplierForecastRepository: ISupplierForecastRepository;
  public recommendOrderRepository: IRecommendOrderRepository;
  public groupRepository: IGroupRepository;
  public trashBinRepository: ITrashBinRepository;
  public registerBusinessRepository: IRegisterBusinessRepository;
  public orderGroupRepository: IOrderGroupRepository;
  public userRepository: IUserRepository;
  public filterInfoRepository: IFilterInfoRepository;
  public customerForecastRepository: ICustomerForecastRepository;
  public verifyUserIdsRepository: IVerifyUserIdsRepository;
  public yearMonthRangeInfoRepository: IYearMonthRangeInfosRepository;
  public orderBasisRepository: IOrderBasisRepository;
  public forecastForReceiptRepository: IForecastForReceiptRepository;
  public kpiRepository: KpiRepository;
  public unmatchedOrderRepository: IUnmatchedOrderRepository;
  public settingRepository: ISettingRepository;
  // #endregion

  // #region UseCases
  public updateOrderUseCase: UpdateOrderUseCase;
  public getUnorderedArrivalUseCase: GetUnorderedArrivalUseCase;
  public bulkDeleteOrderUseCase: BulkDeleteOrderUseCase;
  public bulkRegisterOrderBusinessUseCase: BulkRegisterOrderBusinessUseCase;
  public updateOutputFlagUseCase: UpdateOutputFlagUseCase;
  public updateOrderMemoUseCase: UpdateOrderMemoUseCase;
  public deleteOrderMemoUseCase: DeleteOrderMemoUseCase;
  public saveReminderMailSettingsUseCase: SaveReminderMailSettingsUseCase;
  public updateOrderReminderMailIdUseCase: UpdateOrderReminderMailIdUseCase;
  public getReminderDataUseCase: GetReminderDataUseCase;
  public cleanupOrderReminderMailIdUseCase: CleanupOrderReminderMailIdUseCase;
  public outputOrderUseCase: OutputOrderUseCase;
  public getOrderTemplateListUseCase: GetOrderTemplateListUseCase;
  public getOrderTemplateDetailUseCase: GetOrderTemplateDetailUseCase;
  public createOrderTemplateUseCase: CreateOrderTemplateUseCase;
  public updateOrderTemplateUseCase: UpdateOrderTemplateUseCase;
  public deleteOrderTemplateUseCase: DeleteOrderTemplateUseCase;
  public createOrderTemplateUploadUrlUseCase: CreateOrderTemplateUploadUrlUseCase;
  public getOrderTemplateDownloadUrlUseCase: GetOrderTemplateDownloadUrlUseCase;

  public bulkSaveUnmanagedBusinessUseCase: BulkSaveUnmanagedBusinessUseCase;
  public deleteAllUnmanagedBusinessUseCase: DeleteAllUnmanagedBusinessUseCase;
  public deleteByFileTypeUnmanagedBusinessUseCase: DeleteByFileTypeUnmanagedBusinessUseCase;
  public deleteUnmanagedBusinessUseCase: DeleteUnmanagedBusinessUseCase;
  public getAllUnmanagedBusinessUseCase: GetAllUnmanagedBusinessUseCase;
  public getUnmanagedBusinessUseCase: GetUnmanagedBusinessUseCase;
  public saveUnmanagedBusinessUseCase: SaveUnmanagedBusinessUseCase;

  public getOrderControlUseCase: GetOrderControlUseCase;

  public getAggregateBusinessIdUseCase: GetAggregateBusinessIdUseCase;
  public getBusinessUseCase: GetBusinessUseCase;
  public putLeadTimeUseCase: PutLeadTimeUseCase;
  public putMoqUseCase: PutMoqUseCase;
  public putOrderPackageUseCase: PutOrderPackageUseCase;
  public upsertOrderUseCase: UpsertOrderUseCase;
  public putStdInventoryIndicesUseCase: PutStdInventoryIndicesUseCase;
  public putSupplierForecastUseCase: PutSupplierForecastUseCase;
  public putAggregateBusinessMemoUseCase: PutAggregateBusinessMemoUseCase;
  public deleteAggregateBusinessMemoUseCase: DeleteAggregateBusinessMemoUseCase;

  public saveAggregateBusinessIdsForRecommendOrderUseCase: SaveAggregateBusinessIdsForRecommendOrderUseCase;
  public getAggregateBusinessIdsRecommendOrderListUseCase: GetAggregateBusinessIdsRecommendOrderListUseCase;
  public verifyUserIdsUseCase: VerifyUserIdsUseCase;

  // editBusinessModule
  public getEditBusinessChildBusinessUseCase: GetEditBusinessChildBusinessUseCase;
  public getEditBusinessAggregateBusinessUseCase: GetEditBusinessAggregateBusinessUseCase;
  public putAggregateBusinessUseCase: PutAggregateBusinessUseCase;
  public putBaseBusinessUseCase: PutBaseBusinessUseCase;
  public checkDuplicateAggregateBusinessUseCase: CheckDuplicateAggregateBusinessUseCase;
  public checkDuplicateBaseBusinessUseCase: CheckDuplicateBaseBusinessUseCase;

  public getTableHeaderPreferenceUseCase: GetTableHeaderPreferenceUseCase;
  public getHiddenTableHeaderPreferenceUseCase: GetHiddenTableHeaderPreferenceUseCase;
  public saveTableHeaderPreferenceUseCase: SaveTableHeaderPreferenceUseCase;
  public saveTableHeaderHidePreferenceUseCase: SaveTableHeaderHidePreferenceUseCase;
  public bulkSaveTableHeaderHidePreferenceUseCase: BulkSaveTableHeaderHidePreferenceUseCase;

  public putBusinessMemoUseCase: PutBusinessMemoUseCase;
  public deleteBusinessMemoUseCase: DeleteBusinessMemoUseCase;

  public getInventoryUseCase: GetInventoryUseCase;
  public getInventoryBusinessUseCase: GetInventoryBusinessUseCase;

  // 内示正答率関連
  public forecastAccuracyRepository: IForecastAccuracyRepository;
  public getForecastAccuracyHistoryUseCase: GetForecastAccuracyHistoryUseCase;
  public deleteDeletionAggregateBusinessUseCase: DeleteDeletionAggregateBusinessUseCase;
  public deleteDeletionBaseBusinessUseCase: DeleteDeletionBaseBusinessUseCase;

  public getBusinessNameUseCase: GetBusinessNameUseCase;
  public getBusinessNumberUseCase: GetBusinessNumberUseCase;
  public getWarehouseNameUseCase: GetWarehouseNameUseCase;
  public getWarehouseNumberUseCase: GetWarehouseNumberUseCase;
  public getSupplierNameUseCase: GetSupplierNameUseCase;
  public getSupplierNumberUseCase: GetSupplierNumberUseCase;
  public getCustomerNameUseCase: GetCustomerNameUseCase;
  public getCustomerNumberUseCase: GetCustomerNumberUseCase;
  public getSalesDestinationNameUseCase: GetSalesDestinationNameUseCase;
  public getSalesDestinationNumberUseCase: GetSalesDestinationNumberUseCase;
  public checkNewOptionDuplicateUseCase: CheckNewOptionDuplicateUseCase;
  public createNewAggregateBusinessUseCase: CreateNewAggregateBusinessUseCase;
  public createNewBaseBusinessUseCase: CreateNewBaseBusinessUseCase;
  public upsertTransactionValuesUseCase: UpsertTransactionValuesUseCase;
  public createCombinedOrderUseCase: CreateCombinedOrderUseCase;
  public postOrderGroupUseCase: PostOrderGroupUseCase;
  public getOrderGroupUseCase: GetOrderGroupUseCase;
  public bulkPostOrderToOrderGroupUseCase: BulkPostOrderToOrderGroupUseCase;
  public deleteOrderGroupUseCase: DeleteOrderGroupUseCase;
  public updateOrderGroupUseCase: UpdateOrderGroupUseCase;
  public bulkDeleteOrderToOrderGroupUseCase: BulkDeleteOrderToOrderGroupUseCase;
  public getFilterInfoUseCase: GetFilterInfoUseCase;
  public getAllUsersUseCase: GetAllUsersUseCase;

  public getTableFilterPreferenceUseCase: GetTableFilterPreferenceUseCase;
  public bulkSaveTableFilterPreferenceUseCase: BulkSaveTableFilterPreferenceUseCase;
  public putLastCheckedUseCase: PutLastCheckedUseCase;

  public bulkPutUnpaidOrderedOrderUseCase: bulkPutUnpaidOrderedOrderUseCase;
  public getOrderBasisUseCase: GetOrderBasisUseCase;
  public getRelatedTransactionsDetailUseCase: GetRelatedTransactionsDetailUseCase;
  public getLongTermCustomerForecastUseCase: GetLongTermCustomerForecastUseCase;
  public exportInventoryExcelUseCase: ExportInventoryExcelUseCase;

  // 内示正答率ページ関連
  public getForecastAccuracyRateUseCase: GetForecastAccuracyRateUseCase;
  public exportForecastAccuracyRateUseCase: ExportForecastAccuracyRateUseCase;
  // 客先内示エクスポート
  public exportCustomerForecastUseCase: ExportCustomerForecastUseCase;
  // 担当者ごとの内示回収状況取得
  public bulkGetForecastForReceiptStaffUseCase: BulkGetForecastForReceiptStaffUseCase;
  // 受領用内示ごとの回収状況取得
  public getForecastForReceiptSummaryUseCase: GetForecastForReceiptSummaryUseCase;
  // 受領用内示を作成する
  public createForecastForReceiptUseCase: CreateForecastForReceiptUseCase;
  // 受領用内示に関連取引を追加する
  public addBaseBusinessForecastForReceiptUseCase: AddBaseBusinessForecastForReceiptUseCase;
  // 受領用内示情報を編集する
  public updateForecastForReceiptUseCase: updateForecastForReceiptUseCase;
  // 受領用内示から取引を外す
  public deleteBaseBusinessForecastForReceiptUseCase: DeleteBaseBusinessForecastForReceiptUseCase;
  // 受領用内示を削除する
  public deleteForecastForReceiptUseCase: DeleteForecastForReceiptUseCase;
  // 受領用内示エクセルデータを取得する
  public getOutputForecastForReceiptExcelDataUseCase: GetOutputForecastForReceiptExcelDataUseCase;

  public getInventoryDashboardOverviewUseCase: GetInventoryDashboardOverviewUseCase;
  public getInventoryDashboardDetailAggBizUseCase: GetInventoryDashboardDetailAggBizUseCase;
  public getInventoryDashboardDetailAggBizWithAlertUseCase: GetInventoryDashboardDetailAggBizWithAlertUseCase;
  public getInventoryDashboardDetailBaseBizUseCase: GetInventoryDashboardDetailBaseBizUseCase;
  public getKpiUseCase: GetKpiUseCase;
  public postKpiUseCase: PostKpiUseCase;
  public getAggregateBusinessResponsibleUsersForKpiUseCase: GetAggregateBusinessResponsibleUsersForKpiUseCase;
  public getByDimensionAggBizUseCase: GetByDimensionAggBizUseCase;
  public getByDimensionBaseBizUseCase: GetByDimensionBaseBizUseCase;
  public getDashboardAlertSettingUseCase: GetDashboardAlertSettingUseCase;
  public putDashboardAlertSettingUseCase: PutDashboardAlertSettingUseCase;

  // unmatchedOrderModule
  public getUnmatchedOrdersUseCase: GetUnmatchedOrdersUseCase;
  public updateUnmatchedOrderUseCase: UpdateUnmatchedOrderUseCase;
  public bulkDeleteUnmatchedOrderUseCase: BulkDeleteUnmatchedOrderUseCase;
  public getExistingOrdersUseCase: GetExistingOrdersUseCase;
  public registerUnmatchedOrderBusinessUseCase: RegisterUnmatchedOrderBusinessUseCase;
  public bulkRegisterUnmatchedOrderBusinessUseCase: BulkRegisterUnmatchedOrderBusinessUseCase;

  public getAggregateBusinessUseCase: GetAggregateBusinessUseCase;
  public putRecommendHiddenUseCase: PutRecommendHiddenUseCase;

  public bulkUpdateOrderEtaUseCase: BulkUpdateOrderEtaUseCase;
  // #endregion

  /**
   * Injectionを行う
   */
  constructor() {
    // #region Repositories
    this.aggregateBusinessRepository = new AggregateBusinessRepository();
    this.baseBusinessRepository = new BaseBusinessRepository();
    this.baseBusinessManageRepository = new BaseBusinessManageRepository();
    this.inventoryRepository = new InventoryRepository();
    this.orderRepository = new OrderRepository();
    this.orderTemplateRepository = new OrderTemplateRepository();
    this.unmanagedBusinessRepository = new UnmanagedBusinessRepository();
    this.orderControlRepository = new OrderControlRepository();
    this.supplierForecastRepository = new SupplierForecastRepository();
    this.recommendOrderRepository = new RecommendOrderRepository();
    this.groupRepository = new GroupRepository();
    this.forecastAccuracyRepository = new ForecastAccuracyRepository();
    this.trashBinRepository = new TrashBinRepository();
    this.registerBusinessRepository = new RegisterBusinessRepository();
    this.orderGroupRepository = new OrderGroupRepository();
    this.userRepository = new UserRepository();
    this.filterInfoRepository = new FilterInfoRepository();
    this.customerForecastRepository = new CustomerForecastRepository();
    this.verifyUserIdsRepository = new VerifyUserIdsRepository();
    this.yearMonthRangeInfoRepository = new YearMonthRangeInfoRepository();
    this.orderBasisRepository = new OrderBasisRepository();
    this.forecastForReceiptRepository = new ForecastForReceiptRepository();
    this.kpiRepository = new KpiRepository();
    this.unmatchedOrderRepository = new UnmatchedOrderRepository();
    this.settingRepository = new SettingRepository();
    // #endregion

    // #region UseCases
    this.updateOrderUseCase = new UpdateOrderUseCase(this.orderRepository);
    this.getUnorderedArrivalUseCase = new GetUnorderedArrivalUseCase(this.orderRepository);
    this.bulkDeleteOrderUseCase = new BulkDeleteOrderUseCase(this.orderRepository);
    this.bulkRegisterOrderBusinessUseCase = new BulkRegisterOrderBusinessUseCase(this.orderRepository);
    this.updateOutputFlagUseCase = new UpdateOutputFlagUseCase(this.orderRepository);
    this.updateOrderMemoUseCase = new UpdateOrderMemoUseCase(this.orderRepository);
    this.deleteOrderMemoUseCase = new DeleteOrderMemoUseCase(this.orderRepository);
    this.saveReminderMailSettingsUseCase = new SaveReminderMailSettingsUseCase();
    this.updateOrderReminderMailIdUseCase = new UpdateOrderReminderMailIdUseCase(this.orderRepository);
    this.getReminderDataUseCase = new GetReminderDataUseCase();
    this.cleanupOrderReminderMailIdUseCase = new CleanupOrderReminderMailIdUseCase();
    this.outputOrderUseCase = new OutputOrderUseCase(this.orderRepository);
    this.getOrderTemplateListUseCase = new GetOrderTemplateListUseCase(this.orderTemplateRepository);
    this.getOrderTemplateDetailUseCase = new GetOrderTemplateDetailUseCase(this.orderTemplateRepository);
    this.createOrderTemplateUseCase = new CreateOrderTemplateUseCase(this.orderTemplateRepository);
    this.updateOrderTemplateUseCase = new UpdateOrderTemplateUseCase(this.orderTemplateRepository);
    this.deleteOrderTemplateUseCase = new DeleteOrderTemplateUseCase(this.orderTemplateRepository);
    this.createOrderTemplateUploadUrlUseCase = new CreateOrderTemplateUploadUrlUseCase(this.orderTemplateRepository);
    this.getOrderTemplateDownloadUrlUseCase = new GetOrderTemplateDownloadUrlUseCase(this.orderTemplateRepository);

    this.bulkSaveUnmanagedBusinessUseCase = new BulkSaveUnmanagedBusinessUseCase(this.unmanagedBusinessRepository);
    this.deleteAllUnmanagedBusinessUseCase = new DeleteAllUnmanagedBusinessUseCase(this.unmanagedBusinessRepository);
    this.deleteByFileTypeUnmanagedBusinessUseCase = new DeleteByFileTypeUnmanagedBusinessUseCase(this.unmanagedBusinessRepository);
    this.deleteUnmanagedBusinessUseCase = new DeleteUnmanagedBusinessUseCase(this.unmanagedBusinessRepository);
    this.getAllUnmanagedBusinessUseCase = new GetAllUnmanagedBusinessUseCase(this.unmanagedBusinessRepository);
    this.getUnmanagedBusinessUseCase = new GetUnmanagedBusinessUseCase(this.unmanagedBusinessRepository);
    this.saveUnmanagedBusinessUseCase = new SaveUnmanagedBusinessUseCase(this.unmanagedBusinessRepository);

    this.getOrderControlUseCase = new GetOrderControlUseCase(this.orderControlRepository);

    this.getAggregateBusinessIdUseCase = new GetAggregateBusinessIdUseCase(this.aggregateBusinessRepository);
    this.getBusinessUseCase = new GetBusinessUseCase(this.aggregateBusinessRepository);
    this.putLeadTimeUseCase = new PutLeadTimeUseCase(this.aggregateBusinessRepository);
    this.putMoqUseCase = new PutMoqUseCase(this.aggregateBusinessRepository);
    this.putOrderPackageUseCase = new PutOrderPackageUseCase(this.aggregateBusinessRepository);
    this.upsertOrderUseCase = new UpsertOrderUseCase(this.orderRepository);
    this.putStdInventoryIndicesUseCase = new PutStdInventoryIndicesUseCase(this.aggregateBusinessRepository);
    this.putSupplierForecastUseCase = new PutSupplierForecastUseCase(this.supplierForecastRepository);
    this.putAggregateBusinessMemoUseCase = new PutAggregateBusinessMemoUseCase(this.aggregateBusinessRepository);
    this.deleteAggregateBusinessMemoUseCase = new DeleteAggregateBusinessMemoUseCase(this.aggregateBusinessRepository);

    this.saveAggregateBusinessIdsForRecommendOrderUseCase = new SaveAggregateBusinessIdsForRecommendOrderUseCase(
      this.recommendOrderRepository
    );
    this.getAggregateBusinessIdsRecommendOrderListUseCase = new GetAggregateBusinessIdsRecommendOrderListUseCase(
      this.recommendOrderRepository
    );
    this.verifyUserIdsUseCase = new VerifyUserIdsUseCase(this.verifyUserIdsRepository);

    // editBusinessModule
    this.getEditBusinessAggregateBusinessUseCase = new GetEditBusinessAggregateBusinessUseCase(this.inventoryRepository);
    this.getEditBusinessChildBusinessUseCase = new GetEditBusinessChildBusinessUseCase(this.baseBusinessRepository);
    this.putAggregateBusinessUseCase = new PutAggregateBusinessUseCase(this.aggregateBusinessRepository);
    this.putBaseBusinessUseCase = new PutBaseBusinessUseCase(this.baseBusinessManageRepository);
    this.checkDuplicateAggregateBusinessUseCase = new CheckDuplicateAggregateBusinessUseCase(this.aggregateBusinessRepository);
    this.checkDuplicateBaseBusinessUseCase = new CheckDuplicateBaseBusinessUseCase(this.aggregateBusinessRepository);

    this.getTableHeaderPreferenceUseCase = new GetTableHeaderPreferenceUseCase();
    this.getHiddenTableHeaderPreferenceUseCase = new GetHiddenTableHeaderPreferenceUseCase();
    this.saveTableHeaderPreferenceUseCase = new SaveTableHeaderPreferenceUseCase();
    this.saveTableHeaderHidePreferenceUseCase = new SaveTableHeaderHidePreferenceUseCase();
    this.bulkSaveTableHeaderHidePreferenceUseCase = new BulkSaveTableHeaderHidePreferenceUseCase();
    this.putBusinessMemoUseCase = new PutBusinessMemoUseCase(this.baseBusinessRepository);
    this.deleteBusinessMemoUseCase = new DeleteBusinessMemoUseCase(this.baseBusinessRepository);

    this.getInventoryUseCase = new GetInventoryUseCase(this.inventoryRepository);
    this.getInventoryBusinessUseCase = new GetInventoryBusinessUseCase(this.inventoryRepository);
    this.getForecastAccuracyHistoryUseCase = new GetForecastAccuracyHistoryUseCase(this.forecastAccuracyRepository);
    this.deleteDeletionAggregateBusinessUseCase = new DeleteDeletionAggregateBusinessUseCase(this.trashBinRepository);
    this.deleteDeletionBaseBusinessUseCase = new DeleteDeletionBaseBusinessUseCase(this.trashBinRepository);

    this.getBusinessNameUseCase = new GetBusinessNameUseCase(this.aggregateBusinessRepository);
    this.getBusinessNumberUseCase = new GetBusinessNumberUseCase(this.aggregateBusinessRepository);
    this.getWarehouseNameUseCase = new GetWarehouseNameUseCase(this.aggregateBusinessRepository);
    this.getWarehouseNumberUseCase = new GetWarehouseNumberUseCase(this.aggregateBusinessRepository);
    this.getSupplierNameUseCase = new GetSupplierNameUseCase(this.aggregateBusinessRepository);
    this.getSupplierNumberUseCase = new GetSupplierNumberUseCase(this.aggregateBusinessRepository);
    this.getCustomerNameUseCase = new GetCustomerNameUseCase(this.baseBusinessManageRepository);
    this.getCustomerNumberUseCase = new GetCustomerNumberUseCase(this.baseBusinessManageRepository);
    this.getSalesDestinationNameUseCase = new GetSalesDestinationNameUseCase(this.baseBusinessManageRepository);
    this.getSalesDestinationNumberUseCase = new GetSalesDestinationNumberUseCase(this.baseBusinessManageRepository);
    this.checkNewOptionDuplicateUseCase = new CheckNewOptionDuplicateUseCase(this.registerBusinessRepository);
    this.createNewAggregateBusinessUseCase = new CreateNewAggregateBusinessUseCase(this.aggregateBusinessRepository);
    this.createNewBaseBusinessUseCase = new CreateNewBaseBusinessUseCase(this.baseBusinessManageRepository);
    this.upsertTransactionValuesUseCase = new UpsertTransactionValuesUseCase(this.inventoryRepository);

    this.createCombinedOrderUseCase = new CreateCombinedOrderUseCase(this.orderGroupRepository);
    this.postOrderGroupUseCase = new PostOrderGroupUseCase(this.orderGroupRepository);
    this.getOrderGroupUseCase = new GetOrderGroupUseCase(this.orderGroupRepository);
    this.bulkPostOrderToOrderGroupUseCase = new BulkPostOrderToOrderGroupUseCase(this.orderGroupRepository);
    this.deleteOrderGroupUseCase = new DeleteOrderGroupUseCase(this.orderGroupRepository);
    this.updateOrderGroupUseCase = new UpdateOrderGroupUseCase(this.orderGroupRepository);
    this.bulkDeleteOrderToOrderGroupUseCase = new BulkDeleteOrderToOrderGroupUseCase(this.orderGroupRepository);

    this.getFilterInfoUseCase = new GetFilterInfoUseCase(
      this.filterInfoRepository,
      this.customerForecastRepository,
      this.unmanagedBusinessRepository,
      this.forecastForReceiptRepository,
      this.unmatchedOrderRepository
    );
    this.getAllUsersUseCase = new GetAllUsersUseCase(this.userRepository);
    this.getTableFilterPreferenceUseCase = new GetTableFilterPreferenceUseCase();
    this.bulkSaveTableFilterPreferenceUseCase = new BulkSaveTableFilterPreferenceUseCase();
    this.putLastCheckedUseCase = new PutLastCheckedUseCase(this.aggregateBusinessRepository);
    this.bulkPutUnpaidOrderedOrderUseCase = new bulkPutUnpaidOrderedOrderUseCase(this.orderRepository);
    this.getOrderBasisUseCase = new GetOrderBasisUseCase(this.orderBasisRepository);
    this.getRelatedTransactionsDetailUseCase = new GetRelatedTransactionsDetailUseCase(this.inventoryRepository);
    this.getLongTermCustomerForecastUseCase = new GetLongTermCustomerForecastUseCase();
    this.exportInventoryExcelUseCase = new ExportInventoryExcelUseCase(this.inventoryRepository);

    // 内示正答率ページ関連
    this.getForecastAccuracyRateUseCase = new GetForecastAccuracyRateUseCase(this.customerForecastRepository);
    this.exportForecastAccuracyRateUseCase = new ExportForecastAccuracyRateUseCase(this.customerForecastRepository);
    // 客先内示エクスポート
    this.exportCustomerForecastUseCase = new ExportCustomerForecastUseCase(this.customerForecastRepository);
    // 担当者ごとの内示回収状況取得
    this.bulkGetForecastForReceiptStaffUseCase = new BulkGetForecastForReceiptStaffUseCase(this.forecastForReceiptRepository);
    // 受領用内示ごとの回収状況取得
    this.getForecastForReceiptSummaryUseCase = new GetForecastForReceiptSummaryUseCase(this.forecastForReceiptRepository);
    // 受領用内示を作成する
    this.createForecastForReceiptUseCase = new CreateForecastForReceiptUseCase(this.forecastForReceiptRepository);
    // 受領用内示に関連取引を追加する
    this.addBaseBusinessForecastForReceiptUseCase = new AddBaseBusinessForecastForReceiptUseCase(this.forecastForReceiptRepository);
    // 受領用内示情報を編集する
    this.updateForecastForReceiptUseCase = new updateForecastForReceiptUseCase(this.forecastForReceiptRepository);
    // 受領用内示から取引を外す
    this.deleteBaseBusinessForecastForReceiptUseCase = new DeleteBaseBusinessForecastForReceiptUseCase(this.forecastForReceiptRepository);
    // 受領用内示を削除する
    this.deleteForecastForReceiptUseCase = new DeleteForecastForReceiptUseCase(this.forecastForReceiptRepository);
    // 受領用内示エクセルデータを取得する
    this.getOutputForecastForReceiptExcelDataUseCase = new GetOutputForecastForReceiptExcelDataUseCase(this.forecastForReceiptRepository);

    this.getInventoryDashboardOverviewUseCase = new GetInventoryDashboardOverviewUseCase(this.inventoryRepository);
    this.getInventoryDashboardDetailAggBizUseCase = new GetInventoryDashboardDetailAggBizUseCase(this.inventoryRepository);
    this.getInventoryDashboardDetailAggBizWithAlertUseCase = new GetInventoryDashboardDetailAggBizWithAlertUseCase(
      this.inventoryRepository
    );
    this.getInventoryDashboardDetailBaseBizUseCase = new GetInventoryDashboardDetailBaseBizUseCase(this.inventoryRepository);
    this.getKpiUseCase = new GetKpiUseCase(this.kpiRepository);
    this.postKpiUseCase = new PostKpiUseCase(this.kpiRepository);
    this.getAggregateBusinessResponsibleUsersForKpiUseCase = new GetAggregateBusinessResponsibleUsersForKpiUseCase(
      this.filterInfoRepository
    );
    this.getByDimensionAggBizUseCase = new GetByDimensionAggBizUseCase(this.inventoryRepository);
    this.getByDimensionBaseBizUseCase = new GetByDimensionBaseBizUseCase(this.inventoryRepository);
    this.getDashboardAlertSettingUseCase = new GetDashboardAlertSettingUseCase(this.settingRepository);
    this.putDashboardAlertSettingUseCase = new PutDashboardAlertSettingUseCase(this.settingRepository);

    // unmatchedOrderModule
    this.getUnmatchedOrdersUseCase = new GetUnmatchedOrdersUseCase(this.unmatchedOrderRepository);
    this.updateUnmatchedOrderUseCase = new UpdateUnmatchedOrderUseCase(this.unmatchedOrderRepository);
    this.bulkDeleteUnmatchedOrderUseCase = new BulkDeleteUnmatchedOrderUseCase(this.unmatchedOrderRepository);
    this.getExistingOrdersUseCase = new GetExistingOrdersUseCase(this.unmatchedOrderRepository);
    this.registerUnmatchedOrderBusinessUseCase = new RegisterUnmatchedOrderBusinessUseCase(this.unmatchedOrderRepository);
    this.bulkRegisterUnmatchedOrderBusinessUseCase = new BulkRegisterUnmatchedOrderBusinessUseCase(this.unmatchedOrderRepository);

    this.getAggregateBusinessUseCase = new GetAggregateBusinessUseCase(this.aggregateBusinessRepository);
    this.putRecommendHiddenUseCase = new PutRecommendHiddenUseCase(this.aggregateBusinessRepository);

    this.bulkUpdateOrderEtaUseCase = new BulkUpdateOrderEtaUseCase(this.orderRepository);
    // #endregion
  }
}

export const diContainer = new DiContainer();
